// LikedProduct.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useProductsContext } from "../context/ProductsProvider";
import { useAuthContext } from "../context/AuthContext";
import Products from "./Products";
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import "./slick.css";
import "./slick-theme.css";
import styles from "./Products.module.css";
import { Row, Col } from "react-bootstrap";


export function LikedProduct() {
  const { state } = useProductsContext();
  const { currentUser } = useAuthContext();
  
  // Filter products based on whether the current user has liked them
  const likedProducts = state.items.filter(item => Array.isArray(item.likes) && item.likes.includes(currentUser.uid));
  const navigate = useNavigate();
  return (
    <>
    <FaArrowLeft className="arrow_add" onClick={() => navigate(-1)} />
      <div className={styles.ProductsCategory}>
        <h4>My Liked Products</h4>
      </div>
      <Row xs={2} md={3} lg={5} className="g-0">
        {likedProducts.length > 0 ? (
          likedProducts.map((item, index) => (
            <Col key={index} align="center">
            <Products
              key={item.id}
              id={item.id}
              title={item.title}
              color={item.color}
              size={item.size}
              path={item.path}
              // Add other necessary props here
            />
            </Col>
          ))
        ) : (
          <p className={styles.not_found}>No products found</p>
        )}
      </Row>
    </>
  );
}

// Popular Items

export function PopularItems() {
  const { state } = useProductsContext();
  const [popularItems, setPopularItems] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = popularItems.length;
  let slidesToShow = 6;
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  if (width <= 480) {
    slidesToShow = 2;
  } else if (width > 480 && width <= 600) {
    slidesToShow = 2;
  } else if (width > 600 && width <= 1024) {
    slidesToShow = 3;
  } else {
    slidesToShow = 5;
  }

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength -1 ? 0 : currentSlide + 1);
  }

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength -1 :  currentSlide - 1);
  }

  useEffect(() => {
    setCurrentSlide(0)
  }, []);

  useEffect(() => {
    // Sort items based on likes count in descending order
    const sortedItems = [...state.items].sort((a, b) => b.likes.length - a.likes.length);

    const first20PopularItems = sortedItems.slice(0, 20);

    setPopularItems(first20PopularItems);
  }, [state.items]);

  const NextArrow = (props) => {
    const { onClick, slideCount, currentSlide } = props;
    return (
      <>
        {currentSlide !== slideCount - slidesToShow && (
          <div className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
            <FaArrowRight className="arrow next" onClick={nxetSlide} />
          </div>
        )}
      </>
    );
  };

  const PrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    return (
      <>
        {currentSlide !== 0 && (
          <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
            <FaArrowLeft className="arrow prev" onClick={prevSlide} />
          </div>
        )}
      </>
    );
  };

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToScroll: slidesToShow,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <>
      <div  className={styles.PopularItems}>
        <h4>Most Popular Items</h4>
      </div>
      <div  className={` ${styles.PopularItems_container}`}>
        <Slider {...settings}>
          {popularItems.length > 0 ? (
            popularItems.map((item) => (
              <Products
                key={item.id}
                id={item.id}
                title={item.title}
                color={item.color}
                size={item.size}
                path={item.path}
              />
            ))
          ) : (
            <p className={styles.not_found}>No popular items found</p>
          )}
        </Slider>
      </div>
    </>
  );
}



